<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['anno', 'chartId', 'plants'],
  data: () => ({
    chartdata: {
      labels: [],
      datasets: []
    },
    dataGroups: [],
    options: {
     legend:{
       display:false, 
       align:"end"},
     scales: {
					yAxes: [{
            stacked:true,
						ticks: {
              beginAtZero: true,
              max: 5,
              min: 0,
              stepSize: 1
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
            stacked:true,
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
     responsive: true,
     maintainAspectRatio: false,
     options: {
        // This chart will not respond to mousemove, etc
        onhover: ['click'],
    }

    }
  }),
  watch: {
    anno: function(newVal,oldVal) {
      console.log("anno cambiato da " + oldVal + " a " + this.anno);
      this.buildChart();
    }
  },
  methods: {
    handleClick(point,event) {
      const item = event[0];
      console.log("click event on pos and item", point, item);
      this.$emit("selectedMonth", {source:this.chartId, selectedIndex: item._index, month: this.dataGroups[item._index]});
    },
    buildChart() {
      if (this.anno == '' || this.anno.indexOf('-') <0) {
        this.buildYearChart();
      } else {
        this.buildMonthChart();
      }
    },

    buildYearChart() {

      var endDate = this.moment(new Date()).startOf('month').add(1,'months');
      if (this.anno != '') {
        endDate = this.moment(''+(parseInt(this.anno)+1)+'-01-01','YYYY-MM-dd').startOf('year');
      }
      console.log("end date=" + endDate.format('DD-MM-YYYY'));
      var startDate = this.moment(endDate).subtract(12,'months');
      console.log("intervallo = " + startDate.format('DD-MM-YYYY') + " ... " + endDate.format('DD-MM-YYYY'));

      let self = this;

     //ordina i logbook per data (ultimo il più recente) 
     for(var k=0; k<self.plants.length; k++)
     {
      var regDate = (this.moment(self.plants[k].regdate)).format('MMM-YYYY');
     }
    
    var maxY=0;
    var labels = [];
    var labDate = this.moment(startDate);
    this.dataGroups = [];
    var numPlantsMonth=0;
    var monthPlants;
    var monthPlantsArray=[]; 

    for (var i=0; i<12; i++) {
      labels.push(labDate.format('MMM-YYYY'));
      this.dataGroups.push(labDate.format('YYYY-MM'));
      numPlantsMonth=0;
      for(var k=0; k<self.plants.length; k++)
      {
       var regDate = (this.moment(self.plants[k].regdate)).format('YYYY-MM');
       if (regDate==labDate.format('YYYY-MM'))
       {
          monthPlants=regDate;
          numPlantsMonth++;
       }
      }
      if(monthPlants!=0)
      {
        console.log("plants in ", monthPlants, " n: ", numPlantsMonth);    
        monthPlantsArray.push(numPlantsMonth);   
      }  
      labDate.add(1,'months');
    }

    const maxNumPlants = monthPlantsArray.reduce((a, b) => Math.max(a, b), -Infinity);
    console.log("maxNumsPlants", maxNumPlants);

    this.chartdata.labels = labels;
    this.chartdata.datasets = [];
    this.chartdata.datasets.push({
              barThickness: 20,
              backgroundColor: "#29CC90",
              hoverBorderWidth: 1,
              type: 'bar',
              data: monthPlantsArray
            });

    this.options.scales.yAxes[0].ticks.max=maxNumPlants;     
    this.options.onClick = this.handleClick; 
    this.renderChart(this.chartdata, this.options)

      //console.log("functPlantLogbook: ", functLogbookPlant);
      console.log("chartData:",this.chartdata);


    },

    buildMonthChart() {

      var endDate = this.moment(new Date()).startOf('month').add(1,'months');
      if (this.anno != '') {
        endDate = this.moment(''+this.anno+'-01','YYYY-MM-dd').add(1,'months');
      }
      console.log("end date=" + endDate.format('DD-MM-YYYY'));
      var startDate = this.moment(endDate).subtract(1,'months');
      console.log("intervallo = " + startDate.format('DD-MM-YYYY') + " ... " + endDate.format('DD-MM-YYYY'));

      this.options.scales.yAxes[0].ticks.max=maxY+1;     
      //this.options.onClick = this.handleClick; 
      this.renderChart(this.chartdata, this.options)

      //console.log("functPlantLogbook: ", functLogbookPlant);
      console.log("chartData:",this.chartdata);


    }

  },
  mounted () {
    console.log("chart mounted");
    window.setTimeout(this.buildChart,100);
  }

}
</script>